import React from 'react';
import CollapsiblePanel from "../../base/CollapsiblePanel";
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import PossibleAnswers from "./PossibleAnswers";
import { translate } from "../../base/Translation";
//import { connect } from "react-redux";

/*eslint no-restricted-globals: 0 */

class Question extends React.Component {

	removeQuestion(evt) {
		if (confirm(translate("Ste si istý?")) === false) return;

		this.props.updateQuestion(this.props.question, this.props.section, this.props.group, true);
	}


	onChange(evt) {
		let question = this.props.question;

		if (evt.target.name === "required" || evt.target.name === "irrelevant" || evt.target.name === "bonus") {
			question[evt.target.name] = evt.target.checked;
		} else {
			question[evt.target.name] = evt.target.value;
		}

		this.props.updateQuestion(question, this.props.section, this.props.group, false);
	}


	render() {
		return (
			<CollapsiblePanel title={this.props.question.name ? this.props.question.name : "---"}
				expanded={this.props.question.id < 1} key={this.props.question.id} footer={() => {
					return (
						<div className="text-right">
							<button className="btn btn-danger btn-xs"
								onClick={this.removeQuestion.bind(this)}>{translate("Odstrániť otázku")}
							</button>
						</div>
					)
				}} dragable={true} id={this.props.question.id}>
				<Row>
					<Col lg={12}>
						<FormGroup className="form-group-sm">
							<ControlLabel>{translate("Otázka")}</ControlLabel>
							<FormControl defaultValue={this.props.question.name} onBlur={this.onChange.bind(this)}
								name="name" />
						</FormGroup>
						<FormGroup className="form-group-sm hidden">
							<ControlLabel>{translate("Poznámka")}</ControlLabel>
							<FormControl defaultValue={this.props.question.note} onBlur={this.onChange.bind(this)}
								name="note" />
						</FormGroup>
						<FormGroup className="form-group-sm">
							<ControlLabel>{translate("Poznámka (interná)")}</ControlLabel>
							<FormControl componentClass="textarea" defaultValue={this.props.question.note_internal} onBlur={this.onChange.bind(this)}
								name="note_internal" />
						</FormGroup>
					</Col>
					<Col lg={5}>
						<Row>
							<Col lg={12}>
								<FormGroup className="form-group-sm">
									<ControlLabel>Typ</ControlLabel>
									<FormControl componentClass="select" defaultValue={this.props.question.type}
										onBlur={this.onChange.bind(this)} name="type">
										<option value="text">{translate("Textové pole")}</option>
										<option value="radio">{translate("Výber jednej odpovede")}</option>
										<option value="checkbox">{translate("Výber viacerých odpovedí")}</option>
										<option value="select">{translate("Rozbaľovací výber")}</option>
										<option value="number">{translate("Číslo")}</option>
										<option value="date">{translate("Dátum")}</option>
										<option value="datetime">{translate("Dátum a Čas")}</option>
									</FormControl>
								</FormGroup>
							</Col>
							<Col lg={4}>
								<FormGroup className="form-group-sm">
									<ControlLabel>
										<input type="checkbox"
											defaultValue={this.props.question.required}
											style={{ display: "inline-block" }}
											onChange={this.onChange.bind(this)}
											checked={this.props.question.required}
											name="required" />&nbsp;{translate("Povinné")} </ControlLabel>
								</FormGroup>
							</Col>
							<Col lg={4}>
								<FormGroup className="form-group-sm">
									<ControlLabel>
										<input type="checkbox"
											defaultValue={this.props.question.irrelevant}
											style={{ display: "inline-block" }}
											onChange={this.onChange.bind(this)}
											checked={this.props.question.irrelevant} name="irrelevant" />&nbsp;{translate("Irelevantná")}
									</ControlLabel>
								</FormGroup>
							</Col>
							<Col lg={4}>
								<FormGroup className="form-group-sm">
									<ControlLabel>
										<input type="checkbox"
											defaultValue={this.props.question.bonus}
											style={{ display: "inline-block" }}
											checked={this.props.question.bonus}
											onChange={this.onChange.bind(this)}
											name="bonus" />&nbsp;{translate("Bonusová")} </ControlLabel>
								</FormGroup>
							</Col>
							<Col lg={12} style={{ display: this.props.question.irrelevant ? "block" : "none" }}>
								<FormGroup className="form-group-sm">
									<ControlLabel>{translate("Otázka nie je relevantná")}</ControlLabel>
									<FormControl defaultValue={this.props.question.irrelevant_note} onBlur={this.onChange.bind(this)}
										name="irrelevant_note" />
								</FormGroup>
							</Col>
						</Row>
					</Col>
					<Col lg={7}>
						<PossibleAnswers possible_answers={this.props.question.question_possible_answers}
							section={this.props.section}
							group={this.props.group}
							question={this.props.question.id} />
					</Col>
				</Row>
			</CollapsiblePanel >
		)
	}
}

//export default connect(state => ({ }))(Question);
export default Question;


// WEBPACK FOOTER //
// ./src/modules/form/edit/Question.js